import {
  resetTransmissionState,
  setRoute,
  clearMyPatients,
  toggleMyPatients,
} from "app/store/transmission/slice/transmissionSlice";
import { transmissionTableApi } from "app/store/transmission/api/transmissionTableApi";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { resetAppState } from "app/store/rootActions";
import { cancelSessionExpiry } from "utils/auth";
import {
  CLINIC_ROLES,
  EVOKE_ROLES,
  ROLE_INITIAL_ROUTE,
} from "static/constants";

const useAuth = ({ setAuthToken, setResetPasswordModalOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogin = (responseData, isSwitchRole = false) => {
    const {
      token,
      passwordExpired,
      name,
      role,
      userId,
      user_prefs,
      clinicName,
      hasRPMDevices,
      followingPhysicians = [],
      isFollowingPhysician = false,
      followingHospitals = [],
      isFollowingHospital = false,
      clinii_user_id,
      primary_role,
    } = responseData;

    if (setAuthToken) {
      setAuthToken(token);
    }

    dispatch(transmissionTableApi.util.resetApiState());

    if (passwordExpired && setResetPasswordModalOpen) {
      setResetPasswordModalOpen(true);
    } else {
      cancelSessionExpiry();

      let dataToStore = {};
      const transmissionTableSortingKey = `transmissionTableSorting:${role}:${userId}`;
      const userInitialTableSorting =
        user_prefs?.table_preference?.transmission?.sorting;

      const baseDataToStore = {
        authToken: token,
        role: CLINIC_ROLES.includes(role) ? "clinic" : role,
        userRole: role,
        clinicName: clinicName,
        physician: role === "physician",
        clinicReviewer: role === "clinicReviewer",
        primaryRole: primary_role,
        hasRPMDevices: JSON.stringify(hasRPMDevices),
        timestamp: new Date(),
        clinii_user_id,
        ...(userInitialTableSorting &&
          EVOKE_ROLES.includes(role) && {
            [transmissionTableSortingKey]: JSON.stringify(
              userInitialTableSorting
            ),
          }),
      };

      if (isSwitchRole) {
        localStorage.removeItem("previousPath");

        dataToStore = {
          ...baseDataToStore,
        };
      } else {
        dataToStore = {
          ...baseDataToStore,
          userName: name,
          userId: userId,
          timestamp: new Date(),
          clinicName: clinicName,
          prefs: user_prefs ? JSON.stringify(user_prefs) : "",
          role: CLINIC_ROLES.includes(role) ? "clinic" : role,
          userRole: role,
          physician: role === "physician",
          clinicReviewer: role === "clinicReviewer",
          primaryRole: primary_role,
          hasRPMDevices: JSON.stringify(hasRPMDevices),
          followingPhysicians: followingPhysicians
            ? followingPhysicians.join(",")
            : [],
          isFollowingPhysician,
          followingHospitals: followingHospitals
            ? followingHospitals.join(",")
            : [],
          isFollowingHospital,
        };
      }

      for (const key in dataToStore) {
        localStorage.setItem(key, dataToStore[key]);
      }

      if (!isSwitchRole && user_prefs?.my_patients_toggled) {
        const myPatientsToggledValue =
          localStorage.getItem(`myPatientsToggled:${userId}`) ||
          user_prefs?.my_patients_toggled;

        const myPatientsToggled = myPatientsToggledValue
          ? JSON.parse(myPatientsToggledValue)
          : false;
        dispatch(toggleMyPatients(myPatientsToggled));
      } else if (!isSwitchRole) {
        dispatch(clearMyPatients());
      }

      const route = ROLE_INITIAL_ROUTE[role] || "/transmissions";

      if (isSwitchRole) {
        dispatch(resetAppState());
        navigate(route, { replace: true, state: { appResetAt: Date.now() } });
        return;
      }

      dispatch(setRoute(route));

      const previousPath = localStorage.getItem("previousPath");
      const previousUserId = localStorage.getItem("previousUserId");
      const previousUserRole = localStorage.getItem("previousUserRole");

      if (
        previousPath &&
        previousUserId === userId &&
        previousUserRole === role
      ) {
        ["previousPath", "previousUserId", "previousUserRole"].forEach((key) =>
          localStorage.removeItem(key)
        );

        navigate(previousPath);
      } else {
        navigate(route, { replace: true, state: { appResetAt: Date.now() } });
      }
      dispatch(resetTransmissionState());
    }
  };

  return { handleLogin };
};

export default useAuth;
